import { SVGProps } from 'react';

const SvgCancel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" {...props}>
    <path d="M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c.66 0 1.26.21 1.75.56L1.56 5.75C1.21 5.26 1 4.66 1 4c0-1.66 1.34-3 3-3zm2.44 1.25C6.79 2.74 7 3.34 7 4c0 1.66-1.34 3-3 3-.66 0-1.26-.21-1.75-.56l4.19-4.19z" fill="#fff"/>
  </svg>
)
export default SvgCancel;
